import Link from "next/link"
import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import { getAccessToken } from "lib/Cookies"
import { useEffect, useRef, useState } from "react"
import LoginAlert from "components/ModalLogin/LoginAlert"
import Card3x1 from "components/TypeCard/Card3x1"
import { Modal } from "components/ui"

export default function App(props) {
  let display_type = props.display_type
  const router = useRouter()
  const { toggleModalLogin, userInfo, signKey } = useStore()
  const { id, is_protected } = props
  const isMonter = useRef(false)
  const [isModal, setIsModal] = useState(false)

  function onClick(e) {
    if (is_protected && !getAccessToken()) {
      isMonter.current = true
      setIsModal(true)
      // toggleModalLogin()
      e.preventDefault()
      return false
    }
  }

  function onClose() {
    setIsModal(false)
  }

  function onNext() {
    toggleModalLogin()
    setIsModal(false)
  }

  useEffect(() => {
    if (isMonter.current && userInfo?.fullname) {
      router.push(`/topic?id=${id}`)
    }
  }, [userInfo])

  useEffect(() => {
    if (isMonter.current && signKey) {
      router.push(`/topic?id=${id}`)
    }
  }, [signKey])

  return (
    <>
      <Link href={`/topic?id=${id}`}>
        <div onClick={onClick}>
          <Card3x1 {...props} />
        </div>
      </Link>
      <Modal
        isOpen={isModal}
        onCancel={() => {
          setIsModal(false)
        }}
        showIcon={false}
      >
        <LoginAlert
          onCancel={() => {
            setIsModal(false)
          }}
          onNext={onNext}
        />
      </Modal>
    </>
  )
}
